import { Alert, Button, Checkbox, Col, DatePicker, Form, Input, Row } from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import React, { useState } from 'react'
import { postLogin } from '../../services/api';
import { useMutation } from '@tanstack/react-query';
import { LoginForm, LoginMessages, LoginTitle, LoginWrapper } from './style';

const Login = () => {

    const { mutate: mutateLogin, isLoading, isError }: (any) = useMutation(postLogin);
    const [ errorMessage, setErrorMessage] = useState('');

    const onFinish = (values: any) => {
        mutateLogin(values, {
            onSuccess(data: any) {
                if (data !== '') {
                    document.cookie = `token=${data.token}; max-age=${6*60}; Secure; path=/`;
                    document.cookie = `refreshToken=${data.refreshToken}; max-age=${12*60}; Secure; path=/`;
                    window.location.replace(`/`);
                }
            },
            onError: (error: any) => {
                setErrorMessage(error.response.data.message)
            }
        })
    };
    
    return (
        <LoginWrapper>
            <LoginTitle>Login to CMS</LoginTitle>
            {isError && (
                <LoginMessages>
                    <Alert
                        message="Error"
                        description={isError && errorMessage}
                        type="error"
                        showIcon
                    />
                </LoginMessages>
            )}
            <LoginForm
                name="normal_login"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                style={{ width: "100%" ,maxWidth: 400 }}
            > 
                <Form.Item
                    name="username"
                    rules={[{ required: true, message: 'Please input your Username!' }]}
                >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Please input your Password!' }]}
                >
                    <Input.Password
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="Password"
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button" disabled={isLoading}>Log in</Button>
                </Form.Item>
            </LoginForm>
        </LoginWrapper>
        
    )
}

export default Login